<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> Verification</h6>
</div>
<div class="modal-body">
    <form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
        novalidate>
        <div class="row">
            <label for="UserEnterdOTP" class="form-label">OTP Sent on: <h4 style="color: white; background: var(--success); height: 2rem;display: inline-flex;">{{EmailId}}</h4></label>
            <div class="row py-2">
                <label for="UserEnterdOTP" class="form-label">OTP</label>
                <div class="input-group input-group">
                    <div class="input-group-text"><i class="bi bi bi-lock-fill"></i>
                    </div>

                    <ng-otp-input class="mx-1" (allowNumbersOnly)=true (onInputChange)="onOtpChange($event)"
                        [ngModel]="OTP" #OTP="ngModel" 
                        [config]="{length:6,allowNumbersOnly:true,isPasswordInput:!showPassword}"></ng-otp-input>
                    <div class="input-group-text bg-white" (click)="togglePasswordVisibility()"><i class="bi bi"
                            [ngClass]="{'bi-eye': !showPassword,'bi-eye-slash': showPassword}"></i>
                    </div>
                    <div class="invalid-feedback">
                        Please enter OTP!
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <label (click)="EmpEmailOtpVerify()" class="Resend" *ngIf="!otpButtonDisable"><i
                        class="bi bi-arrow-clockwise"></i> Resend
                    OTP</label>

                <span class="Resend" *ngIf="otpButtonDisable"><i class="bi bi-arrow-clockwise"></i> Resend
                    OTP
                    after {{timingsixty}} sec</span>
            </div>
        </div>
        <div class="row m-1">
            <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Verify':'Loading...'}}</button>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>